import React, { useState, useEffect } from "react";
import "./AdminDashboard.css";
import "./AddEmployee.css";
import { PlacePicker } from "@googlemaps/extended-component-library/react";
import fetchBase from "../utils/fetchBase";
import { Link, useNavigate } from "react-router-dom";
import OuraNav from "../components/OuraNav";

const AddClient = ({ autofillName, countRemaining, onSuccess }) => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        firstName: "",
        lastName: "",
        socDate: "",
        address: "",
        latitude: null,
        longitude: null,
        color: "#007bff",
        clientType: "VA",
        assignedHours: "",
        ssnLastFour: "",
        phone: ""
    });


    // 🟩 Autofill client name when opened from AddMembersChecklist
    useEffect(() => {
        if (autofillName) {
            console.log("🧩 Autofilling client:", autofillName);
            const parts = autofillName.trim().split(" ");
            setFormData((prev) => ({
                ...prev,
                firstName: parts[0] || "",
                lastName: parts.slice(1).join(" ") || "",
            }));
        }
    }, [autofillName]);


    const [success, setSuccess] = useState(false);
    const [successName, setSuccessName] = useState("");
    const [error, setError] = useState("");

    // ✅ Use the new Google Maps Extended Component library (no loader needed)
    const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

    const colorOptions = [
        "#dee2e6", "#6c94b8", "#6f42c1", "#5a2250", "#2d2d2d", "#e0a96d", "#f19029", "#ec5a4c",
        "#c7383b", "#17a2b8", "#28a745", "#20c997", "#343a40", "#6610f2", "#fd7e14", "#b58900"
    ];


    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleAddClient = async () => {



        const authHeader = "Bearer " + localStorage.getItem("jwt_token");

        if (!authHeader) {
            setError("Authorization missing. Please log in again.");
            return;
        }

        console.log("Submitting client form data:", formData);

        // === ADD THIS ONE LINE ===
            console.log("📱 SENDING client data:", JSON.stringify(formData, null, 2));
            // === END ===

        try {
            const response = await fetch(`${fetchBase}/api/client/add`, {

                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": authHeader
                },
                body: JSON.stringify(formData),
            });

            if (response.ok) {
                setSuccessName(formData.firstName);
                setSuccess(true);
                if (onSuccess) onSuccess();
                setTimeout(() => {
                    setSuccess(false);
                }, 800);
                setError("");

                // 🔄 Auto-sync only if live sheet exists on disk
                const fileCheck = await fetch(`${fetchBase}/api/payroll/check-file`, {
                    headers: { "Authorization": "Bearer " + localStorage.getItem("jwt_token") }
                });

                if (fileCheck.status === 200) {
                    await fetch(`${fetchBase}/api/payroll/live-sync`, {
                        method: "GET",
                        headers: { "Authorization": "Bearer " + localStorage.getItem("jwt_token") }
                    });
                }

                // Reset form
                setFormData({
                firstName: "",
                lastName: "",
                socDate: "",
                address: "",
                latitude: null,
                longitude: null,
                color: "#007bff",
                clientType: "VA",
                assignedHours: "",
                ssnLastFour: "",
                phone: ""
            });


                // Keep the success checkmark visible for 2.5s


            }
            else if (response.status === 409) {
                setError("This client already exists.");
            } else {
                const errorText = await response.text();
                setError("Failed to add client. " + errorText);
            }
        } catch (err) {
            console.error("Error adding client:", err);
            setError("Something went wrong.");
        }
    };

    return (
            <>
                <OuraNav
                    links={[
                        { label: "Dashboard", href: "/admin-dashboard" },
                        { label: "Activity", href: "/activity" },
                        { label: "Clients", href: "/admin/clients" },
                        { label: "Employees", href: "/employees" },
                        { label: "Calendar", href: "/Scheduler" }
                    ]}
                />
                <div className="add-employee-container add-client-modal-wrapper" style={{ paddingTop: "70px" }}>
                    <h2 className="admin-title">Add New Client</h2>

            {success && (
                <div className="success-container">
                    <div className="checkmark-circle">✔</div>
                    <p>{successName} added successfully!</p>
                </div>
            )}

            {!success && (
                <div className="admin-form">
                    <input
                        type="text"
                        name="firstName"
                        placeholder="First Name"
                        value={formData.firstName}
                        onChange={handleChange}
                    />
                    <input
                        type="text"
                        name="lastName"
                        placeholder="Last Name"
                        value={formData.lastName}
                        onChange={handleChange}
                    />
                    <label htmlFor="socDate" style={{color: "#222", fontSize: "1rem", marginTop: "10px"}}>
                        Start of Care (SOC) Date
                    </label>
                    <input
                        type="date"
                        id="socDate"
                        name="socDate"
                        value={formData.socDate}
                        onChange={handleChange}
                    />

                    <label style={{color: "#222", fontSize: "1rem", marginTop: "10px"}}>
                            Address
                        </label>
                        <PlacePicker
                            apiKey={apiKey}
                            inputPlaceholder="Client Address"
                            onPlaceChange={(event) => {
                            const place = event.target.value;

                            setFormData(prev => ({
                                ...prev,
                                address: place?.formattedAddress || "",
                                latitude: place?.location?.lat() || null,
                                longitude: place?.location?.lng() || null,
                            }));
                        }}
                    />

                    <label style={{color: "#222", fontSize: "1rem", marginTop: "10px"}}>
                        Program Type
                    </label>

                    <select
                                            name="clientType"
                                            value={formData.clientType}
                                            onChange={handleChange}
                                        >
                                            <option value="VA">VA</option>
                                            <option value="STATE">State</option>
                                        </select>

                                        {formData.clientType === "VA" && (
                                            <>
                                                <label htmlFor="assignedHours" style={{color: "#222", fontSize: "1rem", marginTop: "10px"}}>
                                                    Assigned Hours / week
                                                </label>
                                                <input
                                                    type="number"
                                                    id="assignedHours"
                                                    name="assignedHours"
                                                    placeholder="e.g. 40"
                                                    value={formData.assignedHours || ""}
                                                    onChange={handleChange}
                                                />
                                            </>
                                        )}


                    <label htmlFor="phone" style={{color: "#222", fontSize: "1rem", marginTop: "10px"}}>
                            Phone Number
                        </label>
                        <input
                            type="text"
                            id="phone"
                            name="phone"
                            placeholder="e.g. (555) 222-1212"
                            value={formData.phone}
                            onChange={handleChange}
                        />

                        <label htmlFor="ssnLastFour" style={{color: "#222", fontSize: "1rem", marginTop: "10px"}}>
                            Last 4 of Social
                        </label>
                        <input
                            type="text"
                            id="ssnLastFour"
                            name="ssnLastFour"
                            placeholder="1234"
                            maxLength={4}
                            value={formData.ssnLastFour}
                            onChange={handleChange}
                        />

                        <div className="color-palette">
                        {colorOptions.map((color) => (
                            <div
                                key={color}
                                className={`color-square ${formData.color === color ? "selected" : ""}`}
                                style={{backgroundColor: color}}
                                onClick={() => setFormData({...formData, color})}
                            />
                        ))}
                    </div>

                    {error && <p className="error">{error}</p>}

                    <button onClick={handleAddClient}>Add Client</button>
                    </div>
                )}
                </div>
            </>
        );
    };

export default AddClient;